import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'Components/layout/Button';

import { getRouteByName } from 'Helpers/Routes';

export default class CaseStudyCheckoutV3 extends Component {
    static propTypes = {
        salesmanSlug: PropTypes.string
    };
    static defaultProps = {
        salesmanSlug: null
    };

    salesmans = [
        {
            isDefault: true,
            slug: 'elad',
            avatar: require('Theme/images/videoCaseStudies/videoCaseStudy-checkout-contact-elad.jpg'),
            fullname: 'Elad Matzliah',
            position: 'Head of Sales'
        }, {
            slug: 'stacie',
            avatar: require('Theme/images/videoCaseStudies/videoCaseStudy-checkout-contact-stacie.jpg'),
            fullname: 'Stacie Sussman',
            position: 'Head of US Sales'
        }
    ];

    getSalesman = salesmanSlug => {
        let salesmanIndex = -1;
        //Look for salesman by slug
        salesmanIndex = this.salesmans.findIndex(salesman => salesman.slug === salesmanSlug);

        //Look for salesman by isDefault flag
        if (salesmanIndex === -1) {
            salesmanIndex = this.salesmans.findIndex(salesman => salesman.isDefault);
        }

        //Look for any salesman
        if (salesmanIndex === -1) {
            salesmanIndex = this.salesmans[0];
        }

        return this.salesmans[salesmanIndex];
    }

    getSalesmanMarkup = salesmanSlug => {
        const salesman = this.getSalesman(salesmanSlug);

        return (
            <div className="contact-block">
                <div className="contact-photo-wrapper">
                    <img className="contact-photo" src={salesman.avatar} />
                </div>
                <h4 className="contact-name">{salesman.fullname}</h4>
                <p className="contact-position">{salesman.position}</p>
                <Button
                    element="anchor"
                    to={getRouteByName('missionCostEstimation').path}
                    size="l"
                    layout="wide"
                >
                    I want to learn more
                </Button>
            </div>
        );
    }

    render() {
        const { salesmanSlug } = this.props;

        return (
            <div className="component-case-study-checkout-v3">
                <header className="section-header">
                    <div className="v3-container">
                        <h2 className="section-title">Ready to learn more?</h2>
                        <p className="section-subtitle">Contact me for your piece of crowdsourced visual content magic</p>
                    </div>
                    <img className="background-top" src={require('Theme/images/videoCaseStudies/videoCaseStudy-checkout-top.svg')} />
                </header>
                <div className="v2-container">
                    {this.getSalesmanMarkup(salesmanSlug)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/videoCaseStudy/Checkout/index.js